import { jsxs as h, Fragment as k, jsx as s } from "react/jsx-runtime";
import { $, f as b, C as x } from "../../vendor--aJiswR_.js";
import "react";
import { getSpacingClasses as _ } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index18.css';const j = "_hotkey_6j86w_1", u = "_key_6j86w_11", a = {
  hotkey: j,
  key: u
};
function N({ keys: e, name: c, m: r, mt: n, mr: i, mb: d, ml: p }) {
  const { visuallyHiddenProps: l } = $(), m = b(a.hotkey, _({ m: r, mt: n, mr: i, mb: d, ml: p })), y = e.join(" + "), f = `${c} shortcut: Press ${y}`, t = x();
  return /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ s("kbd", { "aria-describedby": t, className: m, "data-component": "Hotkey", children: e.map((o) => /* @__PURE__ */ s("kbd", { "aria-hidden": !0, className: a.key, children: o }, o)) }),
    /* @__PURE__ */ s("span", { id: t, ...l, children: f })
  ] });
}
export {
  N as Hotkey
};
//# sourceMappingURL=index.js.map
